const pendingInvitationStorageKey = 'stm.pendingInvitation';

/** Long enough to register or reset a forgotten password; short on a shared computer. */
export const pendingInvitationLifetimeMilliseconds = 60 * 60 * 1000;

interface StoredInvitation {
  token: string;
  savedAt: number;
}

function isStoredInvitation(value: unknown): value is StoredInvitation {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as StoredInvitation).token === 'string' &&
    typeof (value as StoredInvitation).savedAt === 'number'
  );
}

/**
 * The invitation code kept while the person signs in, or '' when none is kept or it is older than
 * an hour. It is kept for the whole browser, not one tab, so a password-reset link that opens in a
 * new tab still finds it.
 */
export function readPendingInvitation(now: number = Date.now()): string {
  try {
    const stored = localStorage.getItem(pendingInvitationStorageKey);
    if (stored === null) return '';
    const parsed: unknown = JSON.parse(stored);
    if (
      !isStoredInvitation(parsed) ||
      now - parsed.savedAt > pendingInvitationLifetimeMilliseconds
    ) {
      localStorage.removeItem(pendingInvitationStorageKey);
      return '';
    }
    return parsed.token;
  } catch {
    return '';
  }
}

/** Keeps the code, or forgets it when given ''. */
export function rememberPendingInvitation(token: string, now: number = Date.now()): void {
  try {
    if (token === '') localStorage.removeItem(pendingInvitationStorageKey);
    else {
      const stored: StoredInvitation = { token, savedAt: now };
      localStorage.setItem(pendingInvitationStorageKey, JSON.stringify(stored));
    }
  } catch {
    // Without storage the person opens the link or pastes the code again after signing in.
  }
}
